import { render, staticRenderFns } from "./workspace.html?vue&type=template&id=1b368a5a&scoped=true&external"
import script from "./workspace.js?vue&type=script&lang=js&external"
export * from "./workspace.js?vue&type=script&lang=js&external"
import style0 from "./workspace.scss?vue&type=style&index=0&id=1b368a5a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b368a5a",
  null
  
)

export default component.exports